import React from 'react';
import Button from '@material-ui/core/Button';
import Grid, { GridSpacing } from '@material-ui/core/Grid';
import { useTranslation } from 'react-i18next';

const buttonStyle = {
  maxWidth: '180px',
  maxHeight: '35px',
  minWidth: '180px',
  minHeight: '35px',
};

type EMCSettingFooterProps = {
  onClickSaveButton: () => void;
  onClickCancelButton: () => void;
  buttonEnable: boolean;
};

const EMCSettingFooter: React.FC<EMCSettingFooterProps> = (props) => {
  const { t } = useTranslation();
  return (
    <Grid
      container
      justify="flex-start"
      spacing={1}
      direction="row"
      alignItems="center"
      style={{ width: 'calc(100vw - 12px)' }}
    >
      <Grid item xs={2}>
        <Button
          variant="contained"
          style={buttonStyle}
          color="primary"
          disabled={!props.buttonEnable}
          disableElevation
          onClick={(e) => {
            props.onClickSaveButton();
          }}
        >
          {t('EMCSettingFooter.保存', '保存')}
        </Button>
      </Grid>
      <Grid item xs={2}>
        <Button
          variant="contained"
          style={buttonStyle}
          disabled={!props.buttonEnable}
          color="primary"
          disableElevation
          onClick={(e) => props.onClickCancelButton()}
        >
          {t('EMCSettingFooter.中止', '中止')}
        </Button>
      </Grid>
    </Grid>
  );
};

export default EMCSettingFooter;
